<kendo-dialog [width]="1663" [minHeight]="755" id="schedule-error-dialog" (close)="closeDialogBox(false)" autoFocusedElement=".k-dialog-titlebar-action">
     <kendo-dialog-titlebar>
          <h3 class="section__heading !k-p-0">Error</h3>
     </kendo-dialog-titlebar>
     <div class="content">
          <div>
               <kendo-grid [data]="gridData" class="warning-grid">

                    <!-- Issue Type Column -->
                    <kendo-grid-column title="Issue Type">
                         <ng-template kendoGridCellTemplate let-dataItem>
                              <p style="font-weight: 600; color: #946200;">{{ dataItem.issueType }}</p>
                         </ng-template>
                    </kendo-grid-column>

                    <!-- Description Column -->
                    <kendo-grid-column title="Description">
                         <ng-template kendoGridCellTemplate let-dataItem>

                              <!-- Row 1: Detailed Description -->
                              <ng-container *ngIf="dataItem.descriptionType === 'detailed'">
                                   <p class="speration">
                                        You are attempting to schedule a session where one or more mandates have
                                        scheduling details that do not match the mandated details for the following:
                                   </p>
                                   <ul style="margin-left: 20px;">
                                        <li *ngIf="!dataItem.description.lanaguage">Language</li>
                                        <li *ngIf="!dataItem.description.duration">Duration</li>
                                        <li *ngIf="!dataItem.description.serviceType">Service Type</li>
                                        <li *ngIf="!dataItem.description.size">Group Size</li>
                                        <li *ngIf="!dataItem.description.startDate">Start Date</li>
                                        <li *ngIf="!dataItem.description.gradeOrAge">Grade or Age</li>
                                        <li *ngIf="!dataItem.description.endDate && scheduleDetailsCmp?.showEndData">End
                                             Date</li>
                                   </ul>

                                   <p>If you continue, you are confirming and accepting these mismatches.</p>
                              </ng-container>

                              <!-- Row 2: Simple Paragraph -->
                              <ng-container *ngIf="dataItem.descriptionType === 'simple'">
                                   <p class="speration">You are attempting to schedule at least one mandate that has not
                                        been
                                        accepted/confirmed yet.
                                        If you continue with the scheduling, you are confirming that you will be fully
                                        servicing those mandates.</p>
                              </ng-container>
                              <ng-container *ngIf="dataItem.descriptionType === 'error'">
                                   <p style="font-weight: 700; color: #EC002F;">
                                     No mandates selected. Please select at least one mandate to proceed with scheduling.
                                   </p>
                                 </ng-container>
                         </ng-template>
                    </kendo-grid-column>

               </kendo-grid>

          </div>
     </div>
     <kendo-dialog-actions>
          <div class="flex">
               <button kendoButton themeColor="primary" size="medium" rounded="large" fillMode="outline"
                    class="k-w-full k-mb-8" (click)="closeDialogBox(false)">
                    Go Back
               </button>
               <button kendoButton themeColor="primary" size="medium" rounded="large" fillMode="solid"
                    class="k-w-full k-mb-8" (click)="saveScheduler()"   [disabled]="isScheduleDisabled">
                    Confirm and Schedule
               </button>
          </div>

     </kendo-dialog-actions>
</kendo-dialog>